import { useState } from "react";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";
import { toast } from "sonner";

function Field({ label, ...props }) {
  const t = useTheme();
  return (
    <label className="block">
      <span className="text-[11px] tracking-[0.3em] uppercase opacity-70">{label}</span>
      <input {...props} className={`mt-2 w-full p-3 border ${t.accentBorder} bg-transparent`} />
    </label>
  );
}

export default function Careers() {
  const t = useTheme();
  const [ind, setInd] = useState({ name: "", email: "", phone: "", position: "", cv_url: "" });
  const [biz, setBiz] = useState({ company: "", name: "", email: "", phone: "", message: "" });
  const submit = async (type) => {
    try {
      const payload = type === 'individual'
        ? { type, location: t.location, ...ind, message: "" }
        : { type, location: t.location, ...biz, position: "" };
      await api.post("/careers", payload);
      toast.success("Submission received. Thank you!");
      if (type === 'individual') setInd({ name: "", email: "", phone: "", position: "", cv_url: "" });
      else setBiz({ company: "", name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Submission failed"); }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-testid="careers-page">
      <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>Careers</div>
      <h1 className="mt-3 text-5xl sm:text-6xl" style={{ color: t.text }}>Join the AXtreme story</h1>

      <div className="mt-12 grid md:grid-cols-2 gap-12">
        <div className={`p-8 bg-white border ${t.accentBorder}`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
          <h2 className="text-3xl" style={{ color: t.text }}>Join Our Team</h2>
          <p className="mt-2 opacity-75 text-sm">For individuals applying to work at AXtreme.</p>
          <form onSubmit={(e) => { e.preventDefault(); submit('individual'); }} className="mt-6 grid gap-5" data-testid="career-individual-form">
            <Field label="Full Name" required value={ind.name} onChange={e => setInd({ ...ind, name: e.target.value })} data-testid="career-ind-name" />
            <Field label="Email" type="email" required value={ind.email} onChange={e => setInd({ ...ind, email: e.target.value })} data-testid="career-ind-email" />
            <Field label="Phone" required value={ind.phone} onChange={e => setInd({ ...ind, phone: e.target.value })} data-testid="career-ind-phone" />
            <Field label="Position" placeholder="Stylist, Barber, Manager…" value={ind.position} onChange={e => setInd({ ...ind, position: e.target.value })} data-testid="career-ind-position" />
            <Field label="CV / Resume URL" placeholder="Link to PDF or portfolio" value={ind.cv_url} onChange={e => setInd({ ...ind, cv_url: e.target.value })} data-testid="career-ind-cv" />
            <button type="submit" className={`mt-2 px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="career-ind-submit">Submit Application</button>
          </form>
        </div>

        <div className={`p-8 bg-white border ${t.accentBorder}`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
          <h2 className="text-3xl" style={{ color: t.text }}>Business Partnerships</h2>
          <p className="mt-2 opacity-75 text-sm">For brands & companies interested in collaborating.</p>
          <form onSubmit={(e) => { e.preventDefault(); submit('business'); }} className="mt-6 grid gap-5" data-testid="career-business-form">
            <Field label="Company Name" required value={biz.company} onChange={e => setBiz({ ...biz, company: e.target.value })} data-testid="career-biz-company" />
            <Field label="Contact Name" required value={biz.name} onChange={e => setBiz({ ...biz, name: e.target.value })} data-testid="career-biz-name" />
            <Field label="Email" type="email" required value={biz.email} onChange={e => setBiz({ ...biz, email: e.target.value })} data-testid="career-biz-email" />
            <Field label="Phone" required value={biz.phone} onChange={e => setBiz({ ...biz, phone: e.target.value })} data-testid="career-biz-phone" />
            <label className="block">
              <span className="text-[11px] tracking-[0.3em] uppercase opacity-70">Message</span>
              <textarea rows={4} required value={biz.message} onChange={e => setBiz({ ...biz, message: e.target.value })} className={`mt-2 w-full p-3 border ${t.accentBorder} bg-transparent`} data-testid="career-biz-message" />
            </label>
            <button type="submit" className={`mt-2 px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="career-biz-submit">Send Inquiry</button>
          </form>
        </div>
      </div>
    </div>
  );
}
